import React, { useState } from 'react';
import { Eye, Trash2, MessageSquare } from 'lucide-react';
import { CardMenu } from '../ui';
import { ThreadCardStyled } from './ThreadCard.styles';
import DeleteThreadModal from '../DeleteProjectModal/deleteThreadModal';
import { useNavigate } from 'react-router-dom';

function plainText(value) {
  if (!value) return '';
  return String(value)
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

const ThreadCard = ({ threadCardsData, refetch }) => {
  const navigate = useNavigate();
  const [modal, setModal] = useState(null);

  return (
    <>
      {threadCardsData?.map(card => {
        const title = plainText(card?.title) || 'Untitled chat';
        const preview = plainText(card?.initial_message);
        const updatedAt = plainText(card?.updated_at);

        return (
          <ThreadCardStyled key={card?.session_id}>
            <div className="thread-row">
              <button
                type="button"
                className="icon-btn"
                onClick={() => navigate(`/chat/${card?.session_id}`)}
                aria-label="Open chat">
                <MessageSquare size={20} color="#ff6a3a" />
              </button>
              <button
                type="button"
                className="text-box"
                onClick={() => navigate(`/chat/${card?.session_id}`)}>
                <strong className="title" title={title}>
                  {title}
                </strong>
                {preview ? <p>{preview}</p> : null}
              </button>
              <div className="card-menu">
                <CardMenu
                  items={[
                    {
                      label: 'View Chat',
                      icon: Eye,
                      onClick: () => navigate(`/chat/${card?.session_id}`),
                    },
                    {
                      label: 'Delete Thread',
                      icon: Trash2,
                      onClick: () => setModal({ type: 'delete', card }),
                      danger: true,
                    },
                  ]}
                />
              </div>
            </div>
            {updatedAt ? (
              <div className="card-footer">
                <span className="date">Updated: {updatedAt}</span>
              </div>
            ) : null}
          </ThreadCardStyled>
        );
      })}

      {modal?.type === 'delete' && (
        <DeleteThreadModal onClose={() => setModal(null)} _id={modal.card?.session_id} refetch={refetch} />
      )}
    </>
  );
};

export default ThreadCard;
